module.exports = __webpack_public_path__ + "img/7.53c7abf4.png";